import { render, staticRenderFns } from "./stories.vue?vue&type=template&id=46b50985&scoped=true&"
import script from "./stories.vue?vue&type=script&lang=js&"
export * from "./stories.vue?vue&type=script&lang=js&"
import style0 from "./stories.vue?vue&type=style&index=0&id=46b50985&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b50985",
  null
  
)

export default component.exports